export default __webpack_public_path__ + "static/03-03-math-equation-balancing-c23c45e02d3fc1bfaaab23e402188f5d.mp4";